var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-day-title"},[_c('input-edit-in-place',{staticClass:"ttl",attrs:{"placeholder":"Click to add day title...","name":"title","value":_vm.dietDay.title},on:{"edited":_vm.onEditEvent}}),_vm._v(" "),_c('input-edit-in-place',{staticClass:"note",attrs:{"placeholder":"Click to add day description...","name":"note","value":_vm.dietDay.note},on:{"edited":_vm.onEditEvent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87bd4378","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/programs/shared/schedules/list/cmpt-schedule-day-title.vue
// module id = 3228
// module chunks = 0